import user, { UserState } from "./user";
import loginRequest, { LoginRequestState } from "./loginRequest";
import consents, { ConsentsState } from "./consents";
import purchases, { PurchaseState } from "./eventPurchases";
import receipts, { ReceiptsState } from "./receipts";
import marketingConsents, { MarketingConsentsState } from "./marketingConsents";
import authWithNonce, { LoginNonceRequestState } from "./authWithNonce";

export interface ApplicationState {
  user: UserState;
  loginRequest: LoginRequestState;
  purchases: PurchaseState;
  consents: ConsentsState;
  receipts: ReceiptsState;
  authWithNonce: LoginNonceRequestState;
  marketingConsents: MarketingConsentsState;
}

const reducers = {
  user,
  marketingConsents,
  loginRequest,
  purchases,
  consents,
  authWithNonce,
  receipts,
};

export default reducers;
